<template>
	<ClientOnly>
		<BaseAuthUser>
		<Body :class="'page-auth-profile'" />
			<div class="main">
				<div class="wider-wrapper">
					<div class="main-content">
						<slot name="authContent" />
					</div>
					<div class="aside-cms">
						<BaseAuthUser v-slot="{urls, currentUrl}">
							<ul class="nav-sidebar auth-menu">
								<li class="auth-profile" :class="{'selected': urls.auth == currentUrl}"><NuxtLink :to="urls.auth" ><BaseCmsLabel code="my_profile" tag="span" /></NuxtLink></li>
								<li class="auth-orders" :class="{'selected': urls.auth_my_webshoporder == currentUrl}"><NuxtLink :to="urls.auth_my_webshoporder" ><BaseCmsLabel code="my_orders" tag="span" /></NuxtLink></li>
								<li class="auth-coupons" :class="{'selected': urls.auth_my_webshopcoupon == currentUrl}"><NuxtLink :to="urls.auth+'#coupons'"><BaseCmsLabel code="auth_coupons" tag="span" /></NuxtLink></li>
								<li class="auth-wishlist" :class="{'selected': urls.auth_wishlist == currentUrl}"><NuxtLink :to="urls.auth_wishlist"><BaseCmsLabel code="my_wishlist" tag="span" /></NuxtLink></li>
								<li class="auth-edit" :class="{'selected': urls.auth_edit == currentUrl}"><NuxtLink :to="urls.auth_edit"><BaseCmsLabel code="edit_profile" tag="span" /></NuxtLink></li>
								<li class="auth-password" :class="{'selected': urls.auth_change_password == currentUrl}"><NuxtLink :to="urls.auth_change_password"><BaseCmsLabel code="change_password" tag="span" /></NuxtLink></li>
								<li class="auth-logout"><NuxtLink :to="urls.auth_logout+'?redirect=/'"><BaseCmsLabel code="logout" tag="span" /></NuxtLink></li>
							</ul>
						</BaseAuthUser>
						
						<div :class="['a-intro-loyalty', 'a-loyalty-nocard' && !loyalty?.code]">
							<div v-if="loyalty?.code" class="a-intro-loyalty-cnt">
								<div class="a-intro-loyalty-title">Klub vjernih kupaca</div>
								<p>Svaku narudžbu nagrađujemo</p>
								<div class="a-loyalty-cnt-points">
									<span><strong><BaseCmsLabel code="loyalty_card_number" />:</strong> {{loyalty.code}}</span>
									<span v-if="loyalty.points?.available"><strong><BaseCmsLabel code="loyalty_points" />:</strong> {{loyalty.points.available}}</span>
									<span v-if="loyalty.discount_percent"><strong><BaseCmsLabel code="loyalty_discount" />:</strong> {{loyalty.discount_percent}}%</span>
								</div>
							</div>
							<div v-else class="auth-box-loyalty">
								<div class="auth-box-loyalty-col auth-box-loyalty-col1">
									<div class="auth-loyalty-nocard">
										<div class="auth-title a-intro-loyalty-title" id="loyalty_code_request"><BaseCmsLabel code="auth_loyalty_signup_title" /></div>
										<p>Svaku narudžbu nagrađujemo</p>
										<BaseForm v-if="!loyaltyStatus?.success" @submit="onSubmit">
											<div class="auth-loyalty-field-container">
												<BaseFormField v-for="item in formFields" :key="item.name" :item="item" v-slot="{errorMessage}">
													<label for="loyalty_code"><BaseCmsLabel code="auth_add_loyalty_card" /></label>
													<div class="auth-loyalty-field-card">
														<BaseFormInput :id="item.name" />
														<button type="submit" class="btn btn-attach-card"><UiLoader v-if="loyaltyLoading" /><BaseCmsLabel v-if="!loyaltyLoading" code="attach_card" /></button>
														<span class="error" v-show="errorMessage" v-html="errorMessage" />
														<span v-if="!loyaltyStatus?.success && loyaltyStatus.data?.label_name" class="error">{{loyaltyStatus.data.label_name}}</span>
													</div>
												</BaseFormField>
											</div>
										</BaseForm>									
										<div v-if="loyaltyStatus.data?.label_name == 'success_saved_loyalty_code'" class="global-success auth-loyalty-success"><BaseCmsLabel code="auth_loyalty_attach_card" /></div>
									</div>
								</div>
							</div>						
						</div>
					</div>
				</div>
			</div>
		</BaseAuthUser>
		<template #fallback>
			<BaseThemeUiLoading />
		</template>
	</ClientOnly>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
	const {scrollTo} = useDom();
	const loyaltyLoading = ref(false);
	const loyaltyStatus = ref({});
	const endpoints = useEndpoints();

	const formFields = [{
		"name": "loyalty_code",
		"type": "text",
		"validation": [
			{
				"type": "not_empty",
				"value": null,
				"error": "error_not_empty"
			},
			{
				"type": "max_length",
				"value": 45,
				"error": "error_max_length"
			}
		],
	}]

    const {getCartData, fetchCart} = useWebshop();
	const loyalty = computed(() => {
        return getCartData()?.cart?.loyalty ? getCartData()?.cart?.loyalty : false;
    });	


	async function onSubmit({values}) {
		loyaltyStatus.value = {};
		loyaltyLoading.value = true;	

		loyaltyStatus.value = await useApi(endpoints.get('_post_hapi_auth_loyalty'), {
			method: 'POST',
			body: {loyalty_request: 'e', loyalty_code: values.loyalty_code},
		});

		if(!loyaltyStatus.value.success){
			loyaltyStatus.value = {data: {label_name: 'Greška kod pridruživanja kartice'}};
			return loyaltyLoading.value = false;
		}

		await new Promise(resolve => setTimeout(resolve, 2000));

		await fetchCart();
		
		loyaltyStatus.value = {};
		loyaltyLoading.value = false;	
	}	
</script>